<template>
	<div class="notice-nav">
		<div class="nav-sub2">
			<ul class="nav-sub-ul clearfix">
				<li>
					<a class="router-link-active" href="javascript:;">公告</a>
				</li>
			</ul>
		</div>
		<div class="return-btn" @click="toReturn">返回</div>
	</div>
</template>

<script>
	export default {
		name: 'NoticeNav',
		methods: {
			toReturn(){
				this.$router.go(-1)
			}
		}
	}
</script>

<style scoped>
	.notice-nav{/* position:fixed; top: 92px; left:0; right:0; z-index: 1; background:#fff */}
	.nav-sub2{width:100%; height: 89px;overflow: hidden;}
	.nav-sub-ul{width:1200px;margin:0 auto;}
	.nav-sub-ul li{float: left; margin-right:10%; font-size: 20px; font-weight: bold; line-height: 86px;}
	.nav-sub-ul li a{display: block; width:100%; height: 100%;}
	.nav-sub-ul li a.router-link-active{border-bottom: 3px solid #DE0515;}
	.return-btn{
		float: right;
		width: 81px;
		height: 19px;
		margin-top: -30px;
		background: #DE0515;
		text-align: center;
		line-height: 19px;
		color: #fff;
		font-size: 12px;
	}
</style>
